const GA = window.gtag || (() => null);

export const EVENT_TYPE_PRODUCT = 'product';

export function track(eventName, evenType) {
  GA('event', eventName, {
    eventCategory: evenType,
  });
}

export function trackConversion() {
  GA('event', 'conversion', {
    send_to: 'AW-1026457588/nU5hCNHi7oEYEPT_uekD',
  });
}



// WEBPACK FOOTER //
// ./src/app/utils/eventTrack.js